import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a canvas is moved to a different location',
  name: 'canvas_moved',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The board_id the canvas was moved from, or "canvases" if it was in the root canvases view',
      name: 'original_location',
      required: false,
      type: 'string',
    },
    {
      description: 'The board_id the canvas was moved to, or "canvases" if it was moved to the root canvases view',
      name: 'new_location',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
